export const API_BASE_URL = "https://srinivasafleet.com/api";


function getAuthToken(getToken) {
  return typeof getToken === "function" ? getToken() : localStorage.getItem("token");
}

function buildQuery(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.set(k, v);
  });
  return qs.toString();
}

async function apiGet(apiBaseUrl, path, params, getToken) {
  const token = getAuthToken(getToken);
  const base = apiBaseUrl || API_BASE_URL;
  const url = `${base}${path}?${buildQuery(params)}`;

  const res = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  const contentType = res.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    const text = await res.text();
    throw new Error(
      `Expected JSON from ${url} but got "${contentType || "unknown"}". ` +
        `Check that apiBaseUrl points at your FastAPI server, not the frontend. ` +
        `Response started with: ${text.slice(0, 60)}`
    );
  }

  if (!res.ok) {
    let detail = res.statusText;
    try {
      const body = await res.json();
      detail = body.detail || detail;
    } catch {
      /* ignore parse failure */
    }
    throw new Error(`${res.status} ${detail}`);
  }

  return res.json();
}

export function fetchLiveVehicles(apiBaseUrl, getToken, options = {}) {
  return apiGet(
    apiBaseUrl,
    "/fleetx/live",
    {
      limit: options.limit,
      live_only: options.liveOnly || undefined,
      light: options.light === undefined ? true : options.light,
    },
    getToken
  );
}

export function fetchMyFleetLive(apiBaseUrl, getToken, options = {}) {
  return apiGet(
    apiBaseUrl,
    "/fleetx/live/mine",
    {
      live_only: options.liveOnly || undefined,
      light: options.light === undefined ? true : options.light,
    },
    getToken
  );
}

export function fetchLiveVehicleByNumber(apiBaseUrl, getToken, vehicleNumber) {
  return apiGet(
    apiBaseUrl,
    `/fleetx/live/${encodeURIComponent(vehicleNumber)}`,
    {},
    getToken
  );
}

export function searchLiveVehicles(apiBaseUrl, getToken, query, liveOnly = false) {
  return apiGet(
    apiBaseUrl,
    "/fleetx/live/search",
    { q: query, live_only: liveOnly || undefined },
    getToken
  );
}

export function fetchTripHistory(apiBaseUrl, getToken, vehicleNumber, fromTime, toTime) {
  return apiGet(
    apiBaseUrl,
    "/fleetx/history",
    {
      vehicle_number: vehicleNumber,
      from_time: fromTime,
      to_time: toTime,
    },
    getToken
  );
}

export function fmtTimestamp(epochMs) {
  if (!epochMs) return "—";
  const d = new Date(Number(epochMs));
  if (Number.isNaN(d.getTime())) return String(epochMs);
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const STATUS_LABELS = {
  RUNNING: "Running",
  PARKED: "Parked",
  IDLE: "Idle",
  UNREACHABLE: "Unreachable",
  DISCONNECTED: "Disconnected",
  REMOVED: "Removed",
  NOPOWER: "No Power",
  BATTERY_DISCHARGED: "Battery Discharged",
  IMMOBILISED: "Immobilised",
  STANDBY: "Standby",
  INSHOP: "In Shop",
};

export function statusLabel(status) {
  return STATUS_LABELS[status] || status || "Unknown";
}

const STATUS_TONE = {
  RUNNING: "positive",
  IDLE: "neutral",
  PARKED: "neutral",
  UNREACHABLE: "warning",
  DISCONNECTED: "warning",
  NOPOWER: "warning",
  BATTERY_DISCHARGED: "warning",
  IMMOBILISED: "negative",
  REMOVED: "negative",
};

export function statusTone(status) {
  return STATUS_TONE[status] || "neutral";
}